export default __webpack_public_path__ + "static/media/mobile-abouth265.db5bdd21.mp4";